<template>
  <lottie-player
    ref="lottiePlayer"
    src="Turtle.json"
    background="transparent"
    speed="1"
    autoplay
    loop
    class="background-lottie"
    :style="lottieStyle"
  ></lottie-player>
  <div ref="container" class="container">
    <div class="svg-container">
      <img src="TTGuardian.svg" alt="Background SVG" class="background-svg" />
    </div>    
    <div class="bottom-40 ">  
    <p>Let's check your awareness about Sea Turtle</p>
    <button @click="startQuiz" class="start-quiz-button">Start quiz</button>
  </div>
  </div>
</template>

<script>
import '@lottiefiles/lottie-player';

export default {
  data() {
    return {
      lottieStyle: {
        position: 'absolute',
        width: '15%', // ปรับขนาดแอนิเมชัน
        height: '15%',
        top: window.innerHeight + 'px', // เริ่มจากขอบล่างสุดของหน้าจอ
        left: '0px', // ชิดซ้าย
        opacity: '0.8', // ชิดซ้าย
      },
      startTime: null,
      startPosition: window.innerHeight,
      endPosition: '0px', // จบที่ขอบบนสุดของหน้าจอ
      duration: 30000, // ระยะเวลาในมิลลิวินาที (10 วินาที)
    };
  },
  mounted() {
    // เริ่มเลื่อนแอนิเมชันเมื่อโหลดเสร็จ
    this.startTime = Date.now();
    this.updatePosition();
  },
  methods: {
    startQuiz() {
      this.$router.push('/turtle-guardian');
    },
    updatePosition() {
      const currentTime = Date.now();
      const elapsedTime = currentTime - this.startTime;
      const progress = elapsedTime / this.duration;
      const currentPosition = this.startPosition + (parseInt(this.endPosition) - this.startPosition) * progress;

      this.lottieStyle.top = currentPosition + 'px';

      if (progress < 1) {
        requestAnimationFrame(this.updatePosition);
      } else {
        this.startTime = Date.now(); // เริ่มใหม่
        requestAnimationFrame(this.updatePosition);
      }
    },
  },
};
</script>

<style>
body {
  display: flex;
  flex-direction: column;
}
.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  color: white;
  position: relative;
  overflow: hidden;
}
.svg-container {
  width: 100%;
}
img {
  width: 800px;
}

.start-quiz-button {
  padding: 10px 20px;
  background-color: transparent;
  border: 2px solid white;
  color: white;
  border-radius: 50px;
  cursor: pointer;
  margin-top: 20px; /* เพิ่มระยะห่างระหว่างปุ่มกับข้อความ */
}
.lottie-container {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.background-lottie {
  width: 20%;
  height: 20%;
}
.bottom-40 {
    position: absolute;
    bottom: 40px;  /* This moves the elements 40 pixels up from the bottom */
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;}
</style>
